import React, { useState, useEffect } from "react";
import matrimonyInstance from "../utils/axios";
import { MATRIMONY_SUBSCRIPTION_LIST, SUBSCRIPTION_LIST } from "../API_LIST";
import PaginationComponent from "../component/section/PaginatedItems";

const SubscriptionDataList = () => {
	const [subscriptionList, setSubscriptionList] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [pageNumber, setPageNumber] = useState(1);
	const [countPerPage, setCountPerPage] = useState(9);
	const [isBatSubscriptions, setIsBatSubscriptions] = useState(true);
	const batPlan = {
		price_1R957jJaMQuVGZe3cwYWMasu: "Matrimony Plan",
	};

	const getSubscriptions = async (
		customCountPerPage = countPerPage,
		customPageNumber = pageNumber,
	) => {
		let url = `${MATRIMONY_SUBSCRIPTION_LIST}?limit=${customCountPerPage}&page=${customPageNumber}`;
		if (isBatSubscriptions == false) {
			url = `${SUBSCRIPTION_LIST}?limit=${customCountPerPage}&page=${customPageNumber}`;
		}
		const response = await matrimonyInstance.get(url);
		const data = response?.data;
		setSubscriptionList(data?.subscriptions || []);
		setTotalCount(data?.total_count || 0);
	};

	// useEffect(() => {
	// 	getSubscriptions();
	// }, []);

	useEffect(() => {
		getSubscriptions();
	}, [isBatSubscriptions]);

	function onPageChanged(key, value) {
		if (key === "pageNumber") {
			setPageNumber(value);
			getSubscriptions(countPerPage, value);
		} else if (key === "countPerPage") {
			setCountPerPage(value);
			getSubscriptions(value, 1);
		}
	}

	return (
		<>
			<div className="d-flex flex-column align-items-start pt-25 pl-30">
				<div className="d-flex gap-2 align-items-center pt-25 pl-10">
					<span>Showing</span>
					<select
						style={{ width: "max-content" }}
						className="form-select"
						value={isBatSubscriptions}
						onChange={(e) => setIsBatSubscriptions(e.target.value == "true")}
					>
						<option value={true}>BAT Accounts</option>
						<option value={false}>Matrimony accounts</option>
					</select>
				</div>
			</div>
			<div className="d-flex flex-column align-items-center pt-25 auto">
				<div
					style={{ overflowX: "auto", width: "95%", scrollbarWidth: "thin" }}
				>
					{subscriptionList.length > 0 ? (
						<table id="customers">
							<thead>
								<tr>
									<th>#</th>
									<th>Account Name</th>
									<th>Account Email</th>
									{/* {isBatSubscriptions ? <th>Profile Name</th> : null} */}
									<th>Payment Status</th>
									<th>Subscription Start Date</th>
									<th>Subscription End Date</th>
									<th>Payment Subscription ID</th>
									<th>Payment Plan ID</th>
								</tr>
							</thead>
							<tbody>
								{subscriptionList.map((item, index) => (
									<tr key={index}>
										<td>{(pageNumber - 1) * countPerPage + index + 1}</td>
										<td>
											{item?.account_first_name} {item?.account_last_name}
										</td>
										<td>{item?.account_email}</td>
										{/* {isBatSubscriptions ? (
											<td>
												{item?.profile_first_name} {item?.profile_last_name}
											</td>
										) : null} */}
										<td>{item?.stripe_status}</td>
										<td>{item?.current_period_start?.split("T")[0]}</td>
										<td>{item?.current_period_end?.split("T")[0]}</td>
										<td>{item?.subscription_id}</td>
										<td>{batPlan[item?.plan_id] || item?.plan_id}</td>
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<p className="text-center mt-20">No subscriptions found.</p>
					)}
				</div>
				<PaginationComponent
					totalCount={totalCount}
					onValueChanged={onPageChanged}
					pageNumber={pageNumber}
					countPerPage={countPerPage}
				/>
			</div>
		</>
	);
};

export default SubscriptionDataList;
